import startZendeskSupportChat from "./zendesk";

function startSupportChat() {
  startZendeskSupportChat();
}

export default startSupportChat;
